import { render, staticRenderFns } from "./MyselfCollection.vue?vue&type=template&id=e000a3d2&scoped=true&"
import script from "./MyselfCollection.vue?vue&type=script&lang=js&"
export * from "./MyselfCollection.vue?vue&type=script&lang=js&"
import style0 from "./MyselfCollection.vue?vue&type=style&index=0&id=e000a3d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e000a3d2",
  null
  
)

export default component.exports